module.exports = __webpack_public_path__ + "img/newInt-notview-icon.7509eb50.svg";